module.exports = __webpack_public_path__ + "img/11.fadaa596.jpg";